import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/karta',
    redirectTo: '/aktywacja',
  },
];

export default redirects;
